import {HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from "@angular/common/http";
import {inject} from "@angular/core";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {MessageDialogService} from '../dialog/message-dialog/message-dialog.service';

export const IGNORE_409_ERROR = new HttpContextToken<boolean>(() => false);

export function http409Interceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const messageDialogService = inject(MessageDialogService);

  if (req.context.get(IGNORE_409_ERROR)) {
    return next(req)
  }
  return next(req).pipe(tap(event => {
  }, err => {
    handleError(err, messageDialogService);
  }));
}

function handleError(err: HttpErrorResponse, messageDialogService: MessageDialogService) {
  if (err.status === 409) {
    messageDialogService.open({
      type: 'warning',
      title: 'แจ้งเตือน',
      content: err.error?.errorMessage ?? 'Conflict',
      confirmButtonMsg: 'ตกลง'
    });
  }
}
